import React from 'react';
import './education.scss'

const Education = () => {
	const EducationData = [
		{
			id: 1,
			University: "University of Education",
			startYear: 2016,
			endYear: 2017,
			college: "Education",
			Description: "Completed foundational coursework with a focus on general education principles and introductory subjects.",
		},
		{
			id: 2,
			University: "University of Education",
			startYear: 2017,
			endYear: 2019,
			college: "Education",
			Description: "Studied intermediate courses emphasizing applied learning, research methods, and collaborative projects.",
		},
		{
			id: 3,
			University: "University of Education",
			startYear: 2019,
			endYear: 2022,
			college: "Education",
			Description: "Specialized in advanced subjects, gained hands-on experience through workshops and practical training.",
		},
		{
			id: 4,
			University: "University of Education",
			startYear: 2022,
			endYear: 2024,
			college: "Education",
			Description: "Pursuing final phase of education with focus on professional development, thesis work, and career preparation.",
		}
	];
	
	return (
		<>
			<div className="mainEducation">
				<div className="EducationTitle">
					<h3>Education</h3>
				</div>
				
				<div className="subEducation">
					{
						EducationData.map ((education) => (
							<div className="Education">
								<div className="EducationLedtSection">
									<h3>{education.University}</h3>
									<p>{education.startYear} - {education.endYear}</p>
								</div>
								<div className="EducationRightSection">
									<p>College: {education.college}</p>
									<p>{education.Description}</p>
								</div>
							</div>
						))
					}
				</div>
			</div>
		</>
	);
};

export default Education;